let config = {}

if (window.dbsProductsReviewsConfig) {
  config = {
    apiUrl: window.dbsProductsReviewsConfig.apiUrl,
    reviewsCacheUrl: window.dbsProductsReviewsConfig.reviewsCacheUrl
  }
}

export const ApiConfig = config



// WEBPACK FOOTER //
// ./src/config/apiConfig.js